/**
 * @fileoverview Constants related to Digital Shared libraries
 */

import { TRP_DOMAINS } from '@trp-dms-digital-shared/ds-ui-library-common';

// should be a current version
export const DSUI_DEFAULT_VERSION = 'latest';
// path from root of TRP Domain
export const DSUI_URL_ROOT_PATH = 'shared-assets/ds-ui-library';
// path after version, before filepath
export const DSUI_PKG_FOUNDATION = 'packages/foundation';

/**
 * root URLs for the ds-ui-library in the CDN
 */
export const DsUiCDNRootUrls = {
  DEV: new URL(DSUI_URL_ROOT_PATH, TRP_DOMAINS.DEV).href,
  STAGE: new URL(DSUI_URL_ROOT_PATH, TRP_DOMAINS.STAGE).href,
  PROD: new URL(DSUI_URL_ROOT_PATH, TRP_DOMAINS.PROD).href,
} as const;
